import './cash-out-button.scss';

import { memo, type Ref } from 'react';

import { Button } from '@/shared/ui/Button';

export interface CashOutButtonProps {
  onClick: () => void;
  disabled?: boolean;
  labelRef?: Ref<HTMLSpanElement>;
  label?: string;
}

function CashOutButtonComponent({
  onClick,
  disabled = false,
  labelRef,
  label,
}: CashOutButtonProps) {
  return (
    <Button
      variant="success"
      type="button"
      size="lg"
      className="cash-out-btn"
      onClick={onClick}
      disabled={disabled}>
      <span ref={labelRef} className="cash-out-btn__text">
        {label}
      </span>
    </Button>
  );
}

export const CashOutButton = memo(CashOutButtonComponent);
